import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Loader from 'halogen/RingLoader'
import { Col, Row, Button } from 'react-bootstrap';
import TimeOffTables from './TimeOffTables.js';
import AbsenceTables from './AbsenceTables.js';
import { connect } from 'react-redux';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pastTimeOffs: [],
      upcomingTimeOffs: [],
    }

  }

  render() {
    if (!this.props.user) {
      return (
        <Loader color="#26194b" size="120px" className="loader" />
      )
    }

    return (
      <div className="Dashboard">
        <Row>
          { this.props.user.name ? (
            <h1>Welcome back, {this.props.user.name}!</h1>
          ) : (
            <h1>Welcome back!</h1>
          ) }
        </Row>
        <Row className="actions">
          <Link to='/form'>
            <Button bsStyle="primary">
              Apply for Leave
            </Button>
          </Link>
          {this.props.user.level === 'admin'
            ?  <Link to="/admin">
              <Button bsStyle="primary" style={{marginRight: 10}}>
                Admin
              </Button>
            </Link>
            : null
          }
        </Row>
        <Row>
          <TimeOffTables
            userId={this.props.user.id}
          />
        </Row>
        <Row>
          <Col xs={8} md={4}>
            <AbsenceTables
              userId={this.props.user.id}
            />
          </Col>
        </Row>
      </div>
    );

  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js